import { IModelEntity } from '@pit/core';

export interface IDtoUserRole extends IModelEntity {

    code?: string;
    description?: string;
    level?: number;
    text?: string;

}
